export default
{
  methods:
  {
    /**
     *上传列表分页搜索
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} exp 条件
     * @param {String} init 0/1 首次调用为0, 非第一次为1
     * @param {String} currentPage 当前页
     * @param {String} count 每页的条数
     * @param {String} reorder 排序方式
     */
    find(major, minor, exp, init, currentPage, count, reorder)
    {
      let paras = {
        cmd: 'query',
        _major: major,
        _minor: minor,
        _exp: exp,
        init: init,
        pageno: `${currentPage}`,
        pagesize: `${count}`,
        orderby: reorder ? reorder : `id DESC`
      }
      return window.post.getPost(paras)
    },
    //彻底删除--单
    /**
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     * @param {String} row    //选中行数据
     */
    deletefn(major, minor, row)
    {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'delete',
          _major: major,
          _minor: minor,
          id: row.id
        }
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '删除失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.getList()
            this.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
          }
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    },
    //彻底删除——多
    /**
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     * @param {Array}  tableData  //当前列表页数据
     * @param {Array}  checked  //多选框选中项
     */
    deletesfn(major, minor, tableData, checked)
    {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() =>
      {
        let obj = {
          cmd: 'deletes',
          _major: major,
          _minor: minor,
          ids: checked.toString()
        }
        window.post.getPost(obj).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '删除失败', type: 'error', customClass: 'mzindex'})
          else
          {
            checked.forEach(id =>
            {
              let index = this.tableData.findIndex(e => e.id === id)
              tableData.splice(index, 1)
            })
            this.$message({message: '删除成功', type: 'success', customClass: 'mzindex'})
          }
        })
      }).catch(() =>
      {
        this.$message({message: '已取消删除', type: 'info', customClass: 'mzindex'})
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/plugins/backer/method/methods.js